<template>
  <component :is="component" />
</template>

<script setup lang="ts">
import Desktop from '~/components/desktop/layouts/news/index.vue'
import Mobile from '~/components/mobile/layouts/news/index.vue'
import useBase from '~/composables/useBase'

useBase()
const { $device } = useNuxtApp()
const component = $device.isMobileOrTablet ? Mobile : Desktop
</script>
